/**
 * Created by Jerker Nord on 2020-05-28.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpineScatterSymbol} from "./SpineScatterSymbol";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TextureHelper} from "../../helper/TextureHelper";
import {TimelineLite, TweenLite} from "gsap";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";

export class MonkeysGoldScatterLandView extends BaseView {

    private _spineScatterSymbols:SpineScatterSymbol[];
    private _noOfScattersLanded:number;
    private _bottomFire:TimelineSprite;
    private _bottomFireContainer:PIXI.Container;
    private _bottomFireFSWonTL:TimelineLite;
    private _bottomFireParticles:TimelineSprite;
    private _fireSoundTimer:TimelineLite;
    private _fireSoundPlaying:boolean = false;

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_PRESENTATIONS_3.name).addChild(this);
    }

    protected initAnimations():void {
        this._spineScatterSymbols = [];
        for(let j:number = 0; j < 29; j++) {
            const spineScatterSymbol = new SpineScatterSymbol(GameResources.getSpineAsset("spineBonusLand"));
            spineScatterSymbol.visible = false;
            this.addChild(spineScatterSymbol);
            this._spineScatterSymbols.push(spineScatterSymbol);
        }
        this._bottomFire = new TimelineSprite(GameResources.getTextures("main/FS bottom fire/New/fs_bottom_fire_"));
        this._bottomFire.position.set(0 - ((this._bottomFire.width - 720) / 2), 340);//240
        this._bottomFire.playLoop();

        this._bottomFireContainer = new PIXI.Container();
        this.addChild(this._bottomFireContainer);
        this._bottomFireContainer.addChild(this._bottomFire);

        this._bottomFireParticles = new TimelineSprite(GameResources.getTextures("main/FS bottom fire/fire particle/Fire_particle_"));
        this._bottomFireParticles.position.set(0 - ((this._bottomFire.width - 720) / 2), 340);
        this._bottomFireParticles.blendMode = PIXI.BLEND_MODES.ADD;
        this._bottomFireParticles.hide();
        this._bottomFireContainer.addChild(this._bottomFireParticles);

        const maskContainer:PIXI.Container = new PIXI.Container();
        const maskPartShape = new PIXI.Graphics();
        maskPartShape.beginFill(0xFFFFFF, 1);
        maskPartShape.drawRect(-10, 0, 740, 232);
        maskPartShape.endFill();
        maskPartShape.position.set(0, 0);
        maskContainer.addChild(maskPartShape);

        const maskPartImage:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("main/FS bottom fire/mask")[0]);
        maskPartImage.position.set(-18, 230);
        maskContainer.addChild(maskPartImage);

        const mask:PIXI.Sprite = new PIXI.Sprite(TextureHelper.createRenderedTextureFromContainer(maskContainer));
        maskContainer.destroy({children : true, texture : true});
        mask.position.set(0, 417);
        this._bottomFireContainer.alpha = 0;
        this._bottomFireContainer.addChild(mask);
        this._bottomFireContainer.mask = mask;

        this._fireSoundTimer = new TimelineLite({paused : true, onComplete : () => this.onFireSoundTimeComplete()});
        this._fireSoundTimer.add(() => {}, "+=0.1");
    }

    private onFireSoundTimeComplete():void {
        this._fireSoundPlaying = false;
    }

    public playScatterLandAnimation(scatterSymbol:StateReelSymbol, isBonusGame:boolean, targetPosition:number):void {
        //Return if it's not a new symbol
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].scatterSymbol == scatterSymbol) {
                return;
            }
        }
        this._noOfScattersLanded++;
        const tempSpineScatter:SpineScatterSymbol = this.getUnusedScatterSymbol();
        tempSpineScatter.scatterSymbol = scatterSymbol;
        tempSpineScatter.position.x = Helper.getSymbolPositions(scatterSymbol.reelId, 0)[0];
        if (targetPosition > -1){
            tempSpineScatter.yPos = targetPosition;
        }else{
            tempSpineScatter.yPos = scatterSymbol.position.y;
        }
        tempSpineScatter.updateTransform();
        tempSpineScatter.visible = true;
        tempSpineScatter.spineScatterSymbol.skeleton.setSlotsToSetupPose();
        let activeScatters:number = this.getNumberOfActiveScatters();
        if(isBonusGame == true) {
            activeScatters = 1;
        }
        if(activeScatters > 1) {
            for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
                if(this._spineScatterSymbols[i].visible == true) {
                    if(activeScatters == 2) {
                        this._spineScatterSymbols[i].spineScatterSymbol.skeleton.setSlotsToSetupPose();
                        this._spineScatterSymbols[i].spineScatterSymbol.state.clearTracks();
                        MonkeysGoldGameModuleConfig.monkeysGoldBackgroundSoundController.playScatterLandSound(2);
                        this._spineScatterSymbols[i].enableGreenFrame();
                        this._spineScatterSymbols[i].spineScatterSymbol.state.addAnimation(0, "bonus_animation", true, 0);
                        TweenLite.to(this._bottomFireContainer, 0.2, {alpha : 1});
                        (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                            name : (MonkeysGoldSoundConfig.instance.FLAMES_LOOP),
                            repeat : Infinity
                        });
                    } else {
                        MonkeysGoldGameModuleConfig.monkeysGoldBackgroundSoundController.playScatterLandSound(3);
                        this._spineScatterSymbols[i].enableLevel3Scatter(this._noOfScattersLanded > 3);
                        this.playBottomFireFSWon();
                    }
                }
            }
        } else {
            MonkeysGoldGameModuleConfig.monkeysGoldBackgroundSoundController.playScatterLandSound(1);
            tempSpineScatter.spineScatterSymbol.state.setAnimation(0, "bonus_animation", true);
        }
    }

    private playFireStartSound():void{
        if(this._fireSoundPlaying == false) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : (MonkeysGoldSoundConfig.instance.FLAMES_START),
            });
            this._fireSoundPlaying = true;
            this._fireSoundTimer.restart();
        }
    }

    private playBottomFireFSWon():void {
        this._bottomFireFSWonTL = new TimelineLite();
        this._bottomFireFSWonTL.add(() => this._bottomFire.position.y = 340);
        this._bottomFireFSWonTL.add([
            TweenLite.to(this._bottomFire.position, 0.5, {y : 240}),
            () => this.playFireStartSound()
        ]);
        this._bottomFireFSWonTL.add(this._bottomFireParticles.getAnimationAutoShowHide(), "-=0.2");
        this._bottomFireFSWonTL.add(TweenLite.to(this._bottomFire.position, 0.5, {y : 340}), "-=0.6");
    }

    public endBottomFire():void {
        TweenLite.to(this._bottomFireContainer, 0.2, {alpha : 0});
        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.FLAMES_LOOP);
        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.FLAMES_START);
    }

    private getNumberOfActiveScatters():number {
        let activeScatters:number = 0;
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].visible == true) {
                activeScatters++;
            }
        }
        return activeScatters;
    }

    // @ts-ignore
    private getUnusedScatterSymbol():SpineScatterSymbol {
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].visible == false) {
                return this._spineScatterSymbols[i];
                break;
            }
        }
    }

    public getIsActiveScatter(symbol:StateReelSymbol):SpineScatterSymbol | null {
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].scatterSymbol == symbol) {
                return this._spineScatterSymbols[i];
            }
        }
        return null;
    }

    public cleanUp(reelId:number):void {
        this._noOfScattersLanded = 0;
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].visible == true) {
                if(this._spineScatterSymbols[i].scatterSymbol.reelId == reelId) {
                    this._spineScatterSymbols[i].scatterSymbol.visible = true;
                    this._spineScatterSymbols[i].visible = false;
                    this._spineScatterSymbols[i].disableGreenFrame();
                    this._spineScatterSymbols[i].reset();
                }
            }
        }
    }

    public cleanUpAllScatters():void {
        for(let i:number = 0; i < 6; i++) {
            this.cleanUp(i);
        }
    }

    public getAllActiveScatters():SpineScatterSymbol[] {
        const activeScatters:SpineScatterSymbol[] = [];
        for(let i:number = 0; i < this._spineScatterSymbols.length; i++) {
            if(this._spineScatterSymbols[i].visible == true) {
                activeScatters.push(this._spineScatterSymbols[i]);
            }
        }
        return activeScatters;
    }
}